<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M14.4121 1.91204C14.168 2.15613 14.168 2.54896 14.168 3.33464V14.168C14.168 14.9536 14.168 15.3465 14.4121 15.5906C14.6561 15.8346 15.049 15.8346 15.8346 15.8346C16.6203 15.8346 17.0131 15.8346 17.2572 15.5906C17.5013 15.3465 17.5013 14.9536 17.5013 14.168V3.33464C17.5013 2.54896 17.5013 2.15613 17.2572 1.91204C17.0131 1.66797 16.6203 1.66797 15.8346 1.66797C15.049 1.66797 14.6561 1.66797 14.4121 1.91204Z"
      fill="currentColor"
    />
    <path
      d="M8.33203 5.83464C8.33203 5.04896 8.33203 4.65613 8.57611 4.41204C8.8202 4.16797 9.21303 4.16797 9.9987 4.16797C10.7844 4.16797 11.1772 4.16797 11.4213 4.41204C11.6654 4.65613 11.6654 5.04896 11.6654 5.83464V14.168C11.6654 14.9536 11.6654 15.3465 11.4213 15.5906C11.1772 15.8346 10.7844 15.8346 9.9987 15.8346C9.21303 15.8346 8.8202 15.8346 8.57611 15.5906C8.33203 15.3465 8.33203 14.9536 8.33203 14.168V5.83464Z"
      fill="currentColor"
    />
    <path
      d="M2.74408 7.74407C2.5 7.98816 2.5 8.381 2.5 9.16667V14.1667C2.5 14.9523 2.5 15.3452 2.74408 15.5892C2.98816 15.8333 3.38099 15.8333 4.16667 15.8333C4.95234 15.8333 5.34517 15.8333 5.58926 15.5892C5.83333 15.3452 5.83333 14.9523 5.83333 14.1667V9.16667C5.83333 8.381 5.83333 7.98816 5.58926 7.74407C5.34517 7.5 4.95234 7.5 4.16667 7.5C3.38099 7.5 2.98816 7.5 2.74408 7.74407Z"
      fill="currentColor"
    />
    <path
      d="M2.5 17.7109C2.15483 17.7109 1.875 17.9908 1.875 18.3359C1.875 18.6811 2.15483 18.9609 2.5 18.9609H17.5C17.8452 18.9609 18.125 18.6811 18.125 18.3359C18.125 17.9908 17.8452 17.7109 17.5 17.7109H2.5Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'EbsReportsIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>